export const purchaseIntentOptions = [
    {   value: "definitely_will_buy", label: "Definitely will buy"},
    {   value: "probably_will_buy", label: "Probably will buy"},
    {   value: "unsure", label: "Unsure"}, 
    {   value: "probably_wont_buy", label: "Probably won’t buy"},
    {   value: "definitely_wont_buy", label: "Definitely won’t buy."},
];